import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { template } from 'utils/TemplateReplacement';
import './style.css';

// eslint-disable-next-line react/prefer-stateless-function
class RemoveUsersToRoomNoticeMessageItem extends Component {
  render() {
    const { message } = this.props;
    return (
      <div style={{ textAlign: 'center' }}>
        <div className="message-notice">
          {template(message.messageMeta.noticeMessageTemplate, {
            changedUsername: (
              <Link
                key={`changedUserNotice-${message.id}-${message.messageMeta.changedUserId}`}
                to={`/users/profile/${message.messageMeta.changedUserId}`}
              >
                {message.messageMeta.changedUsername}
              </Link>
            ),
            deletedUsers: message.messageMeta.deletedUsers
              .map(newUser => (
                <Link
                  key={`deletedUserNotice-${message.id}-${newUser.id}`}
                  to={`/users/profile/${newUser.id}`}
                >
                  {newUser.username}
                </Link>
              ))
              .reduce((prev, curr) => [prev, ', ', curr])
          })}
        </div>
      </div>
    );
  }
}

RemoveUsersToRoomNoticeMessageItem.propTypes = {
  message: PropTypes.shape({
    id: PropTypes.number.isRequired,
    messageMeta: PropTypes.shape({
      noticeMessageTemplate: PropTypes.string.isRequired,
      changedUsername: PropTypes.string.isRequired,
      deletedUsers: PropTypes.arrayOf(PropTypes.shape).isRequired,
      changedUserId: PropTypes.number.isRequired
    }).isRequired
  }).isRequired
};

export default RemoveUsersToRoomNoticeMessageItem;



// WEBPACK FOOTER //
// ./src/components/Messenger/content/RoomViewBlock/RoomMainBlock/_messages/RemoveUsersToRoomNoticeMessageItem.js